<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="administrador-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putAdministrador)">
          <ModalOrganosAdministradores :currentAdministrador="currentAdministrador" @submit.prevent :complete="true" />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="vigilancia-modal" title="" hide-footer id="modalV" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putVigilancia)">
          <ModalOrganosVigilancia :currentVigilancia="currentVigilancia" @submit.prevent :complete="true" />
        </form>
      </ValidationObserver>
    </b-modal>

    <h4 class="cardD">Administradores</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los admnistradores.</label>

    <div class="row">
      <div class="col-12">
        <label v-if="constitutiva.tipo_societario === 'SA' || constitutiva.tipo_societario === 'SAPI'">Administradores</label>
        <label v-if="constitutiva.tipo_societario === 'S de RL'">Gerentes</label>

        <b-table hover :fields="fieldsCuadroAdmin" :items="constitutiva.administradores">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editAdministrador(item)"
              :disabled="disabledOrganosCorporativosComputed"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <h4 class="cardD mt-3">Vigilancia</h4>
    <label class="leyenda blue-text-important">Agrega el RFC a cada uno de los comisarios.</label>

    <div
      v-if="
        constitutiva.tipo_administracion === 'Consejo de Administración' ||
        constitutiva.tipo_administracion === 'Consejo de Gerentes'
      "
    ></div>

    <div class="row">
      <div class="col md-12">
        <label for="">Comisario u Órgano de Vigilancia</label>
        <div>
          <label class="mb-12 leyenda blue-text-important" v-if="constitutiva.tipo_societario === 'S de RL'">
            Campo opcional
          </label>
        </div>

        <b-table hover :fields="fieldsCuadroVigilancia" :items="constitutiva.vigilancia">
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editVigilancia(item)"
              :disabled="disabledOrganosCorporativosComputed"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.rfc">
              <div class="circle completado_green" v-if="item.rfc.length === 13">
                <span class="number"><i class="fa fa-check"></i></span>
              </div>
              <div class="circle completado_yellow" v-else>
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
            <div v-else>
              <div class="circle completado_yellow">
                <span class="number"><i class="fa fa-minus"></i></span>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <div class="mt-4">
      <div class="row">
        <div class="col-10">
          <b-button
            type="submit"
            class="btn-fill orange-btn bottom2"
            size="m"
            :disabled="disabledOrganosCorporativosComputed || !canValidate"
          >
            Guardar
          </b-button>
        </div>
        <div class="col-2">
          <b-button
            variant="success"
            class="btn-fill bottom2"
            size="m"
            :disabled="disabledOrganosCorporativosComputed || !canValidate"
            @click="validar()"
          >
            Validar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalOrganosAdministradores from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosAdministradores.vue";
import ModalOrganosVigilancia from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosVigilancia.vue";

export default {
  name: "OrganosCorporativos",

  computed: {
    fieldsCuadroAdmin() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "cargo", label: "Cargo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },
    fieldsCuadroVigilancia() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "cargo", label: "Cargo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },
    disabledOrganosCorporativosComputed() {
      return this.constitutiva.disabledOrganosCorporativos || this.constitutiva.validoOrganosCorporativos;
    },
  },

  created() {
    this.enableSave();
  },

  watch: {
    "constitutiva.administradores": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
    "constitutiva.vigilancia": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
  },

  components: {
    ModalOrganosAdministradores,
    ModalOrganosVigilancia
  },

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      loading: false,
      canValidate: false,

      currentAdministrador: null,
      currentAdministradorId: null,
      currentVigilancia: null,
      currentVigilanciaId: null,
    };
  },

  methods: {
    enableSave() {
      let count = 0;
      this.constitutiva.administradores.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      this.constitutiva.vigilancia.forEach((item) => {
        if (item.rfc) {
          if (item.rfc.length != 13) {
            count++;
          }
        } else {
          count++;
        }
      });
      if (count === 0) {
        this.canValidate = true;
      } else {
        this.canValidate = false;
      }
    },

    editAdministrador(item) {
      this.currentAdministrador = item;
      this.$refs["administrador-modal"].show();
    },

    putAdministrador() {
      if (!this.currentAdministrador.id) {
        let id = this.constitutiva.administradores.length + 1;
        this.currentAdministrador.id = id;
        var a = Object.assign({}, this.currentAdministrador);
        this.constitutiva.administradores.push(a);
      } else {
        let index = this.constitutiva.administradores.findIndex(
          // (o) => o.id === this.currentAdministradorId
          (o) => o.id === this.currentAdministrador.id,
        );
        var a = Object.assign({}, this.currentAdministrador);
        // this.constitutiva.administradores[index] = a;
        this.constitutiva.administradores.splice([index], 1, a);
      }
      this.$refs["administrador-modal"].hide();
    },

    async editVigilancia(item) {
      this.$refs["vigilancia-modal"].show();
      this.currentVigilancia = item;
      // const valid = await this.$refs.provider.errors(this.currentVigilancia);
    },

    putVigilancia() {
      if (!this.currentVigilancia.id) {
        let id = this.constitutiva.vigilancia.length + 1;
        this.currentVigilancia.id = id;
        var a = Object.assign({}, this.currentVigilancia);
        this.constitutiva.vigilancia.push(a);
      } else {
        let index = this.constitutiva.vigilancia.findIndex((o) => o.id === this.currentVigilancia.id);
        var a = Object.assign({}, this.currentVigilancia);
        // this.constitutiva.vigilancia[index] = a;
        this.constitutiva.vigilancia.splice([index], 1, a);
      }
      this.$refs["vigilancia-modal"].hide();
    },

    validar() {
      this.$emit("validaForm", "OrganosCorporativos");
    },
  },
};
</script>

<style scoped>
.completado_green {
  background-color: yellowgreen !important;
}

.completado_yellow {
  background-color: gold !important;
}
</style>
